import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { getSiloData, updateSilo } from '../../services/Silo/siloService';
import ErrorModal from '../Modals/ErrorModal';
import SuccessModal from '../Modals/SuccessModal';
import InputField from '../Utils/InputField';
import WeightInput from '../Utils/WeightInput';
import HarvestInput from '../Utils/HarvestInput';

const EditSiloModal = ({ show, handleClose, silo, refreshSilos }) => {
  const { register, handleSubmit, setValue, control, formState: { errors }, reset } = useForm();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const fetchSiloData = async () => {
      try {
        if (silo?.id) {
          const data = await getSiloData(silo.id);
          setValue('oldId', data?.oldId);
          setValue('name', data.name);
          setValue('capacity', data.capacity.toFixed(3).replace(',', '.'));
          setValue('stock', data.stock);
          setValue('harvestId', { id: data.harvest?.id, description: data.harvest?.description });
        }
      } catch (error) {
        setErrorMessage(error.message || 'Erro ao buscar dados do silo.');
        setShowErrorModal(true);
      }
    };

    if (show && silo) {
      fetchSiloData();
    } else if (!show) {
      reset();
    }
  }, [show, silo, setValue, reset]);

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      harvestId: data.harvestId?.id,
    };

    try {
      await updateSilo(silo.id, payload);
      setSuccessMessage('Silo atualizado com sucesso!');
      setShowSuccessModal(true);
      reset();
    } catch (error) {
      setErrorMessage(error.message || 'Erro ao atualizar silo.');
      setShowErrorModal(true);
    }
  };

  const handleCloseErrorModal = () => setShowErrorModal(false);
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    refreshSilos();
    handleClose();
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Editar Silo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col md={8}>
                <InputField
                  label="Nome"
                  name="name"
                  placeholder="Digite o nome"
                  register={register}
                  errors={errors}
                  rules={{ required: 'Nome é obrigatório' }}
                />
              </Col>
              <Col md={4}>
                <Controller
                  name="capacity"
                  control={control}
                  rules={{ required: 'Capacidade é obrigatório' }}
                  render={({ field, fieldState }) => (
                    <WeightInput
                      value={field.value}
                      onChange={field.onChange}
                      label="Capacidade"
                      isInvalid={!!fieldState.error}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Controller
                  name="harvestId"
                  control={control}
                  render={({ field, fieldState }) => (
                    <HarvestInput
                      value={field.value}
                      onChange={(selectedHarvest) => setValue('harvestId', selectedHarvest)}
                      label="Safra"
                      isInvalid={!!fieldState.error}
                      createdNew={true}
                    />
                  )}
                />
              </Col>
            </Row>
            <Button variant="primary" className="button-custom w-100 mt-3" type="submit">
              Atualizar
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <ErrorModal
        show={showErrorModal}
        handleClose={handleCloseErrorModal}
        errorMessage={errorMessage}
      />

      <SuccessModal
        show={showSuccessModal}
        handleClose={handleCloseSuccessModal}
        successMessage={successMessage}
      />
    </>
  );
};

export default EditSiloModal;